import { render, staticRenderFns } from "./CardSolPagoBse.vue?vue&type=template&id=0f89bd1a&"
import script from "./CardSolPagoBse.vue?vue&type=script&lang=js&"
export * from "./CardSolPagoBse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports